import { Shield } from "lucide-react";

/**
 * RGPD / GDPR data protection notice. To be shown on any form collecting personal data.
 * - compact mode: small one-line link/icon (no full text)
 * - detailed: full block with the legal text
 */
export default function GdprNotice({ compact = false }) {
  if (compact) {
    return (
      <p className="text-[10px] leading-relaxed text-neutral-500" data-testid="gdpr-compact">
        En validant, vous acceptez le traitement de vos données dans le cadre de l'événement et la réception de communications La WineTech. <a href="/privacy" className="font-semibold text-wine-600 hover:underline">En savoir plus →</a>
      </p>
    );
  }
  return (
    <div className="rounded-2xl border border-neutral-200 bg-neutral-50/60 p-4" data-testid="gdpr-block">
      <div className="flex items-start gap-2.5">
        <Shield className="mt-0.5 h-4 w-4 shrink-0 text-wine-500" />
        <div className="text-[11px] leading-relaxed text-neutral-600">
          <strong className="block text-neutral-800">Protection des données personnelles</strong>
          <p className="mt-1">
            En communiquant vos coordonnées et en validant votre inscription, vous acceptez que <strong>La WineTech</strong> collecte et traite vos données personnelles dans le cadre de l'organisation de cet événement, de la gestion de votre participation et de l'envoi d'informations relatives à cet événement.
          </p>
          <p className="mt-1.5">
            Vous acceptez également de recevoir des communications concernant les activités, événements, services et actualités de La WineTech.
          </p>
          <p className="mt-1.5">
            Dans le cadre de l'organisation de l'événement, vos données pourront être transmises aux partenaires, coorganisateurs, sponsors, exposants et membres de l'association impliqués dans la réalisation de l'événement ou dans le développement de collaborations professionnelles en lien avec l'écosystème WineTech.
          </p>
          <p className="mt-1.5">
            Vos données sont traitées conformément au <strong>RGPD</strong>. Vous pouvez exercer vos droits d'accès, de rectification, d'effacement, d'opposition ou de limitation en contactant <a href="mailto:dpo@lawinetech.com" className="font-semibold text-wine-600 hover:underline">dpo@lawinetech.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
